import React from 'react';
import ApiPage from '@/components/Pages/ApiPage';
import '@/components/Api/api.css';

export default function Api() {
  return <ApiPage />;
}
